export const WC_PROMOTION_ELIGIBLE_SPORT_TYPES = [1, 997, 9994, 9995];
export const WC_PROMOTION_ELIGIBLE_BET_TYPES = new Set([1, 3, 6, 7, 8, 29, 159, 161, 162, 412, 413, 414, 417, 448]);

/** Spin tab opens at this instant (GMT-4). */
export const WC_PROMOTION_SPIN_TAB_STARTS_AT_MS = Date.parse('2026-07-20T00:00:00-04:00');

/** After party tab opens at this instant (GMT-4). */
export const WC_PROMOTION_PARTY_TAB_STARTS_AT_MS = Date.parse('2026-08-01T00:00:00-04:00');

/** World Cup Promotion ended time (GMT-4). */
export const WC_PROMOTION_ENDED_TIME = Date.parse('2026-08-08T00:00:00-04:00');

/** WC promotion activity asset locale list. 使用前請先確定這些語系的圖片存在(除了zhcn會轉換為cs) */
export const WC_PROMOTION_ACTIVITY_ASSET_LOCALE_LIST = ['beng', 'ch', 'cs', 'zhcn', 'id', 'jp', 'ko', 'th', 'vn', 'en', 'tr'];